/**
 * @return {string}
 */
export function moneyFormat (money) {
  return (money + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}
